import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import { resetPassword } from "../../../redux/auth/actions";
import { Button, Form } from "react-bootstrap";
import { IoIosEye, IoIosEyeOff } from "react-icons/io";
import { APP_CONST } from "../../../config/const";
import { Toaster } from "../../../utils/toaster";
import LoginBanner from "../../../assets/images/banner/login.webp";
import LoginBannerMob from "../../../assets/images/banner/loginmob.webp";

const ResetPassword = ({ show, handleClose, handleModalShow }) => {
  const [showPassword, setShowPassword] = useState(false);
  const [otp, setOtpValue] = useState("");
  const [password, setPassword] = useState("");
  const [isVerifying, setIsVerifying] = useState(false);

  const handleSubmit = () => {
    if (otp == "" || password == "") {
      Toaster(APP_CONST.TOAST_TYPE.ERROR, "All fields are mandatory");
    } else {
      const payload = {
        otp,
        password,
      };

      setIsVerifying(true);
      resetPassword(payload)
        .then((res) => {
          setIsVerifying(false);
          Toaster(APP_CONST.TOAST_TYPE.SUCCESS, "Password reset success");
          // navigate("/sign-in");
          handleClose();

          handleModalShow(APP_CONST.AUTH_MODAL.LOGIN);
        })
        .catch((err) => {
          setIsVerifying(false);
          Toaster(
            APP_CONST.TOAST_TYPE.ERROR,
            err.response.data.message || "Request failed"
          );
        });
    }
  };

  return (
    <Modal
      show={show}
      className={"steps-canvas login-modal"}
      onHide={() => {
        console.log("working");
      }}
      placement={"end"}
    >
      <div className="modalSection">
        <div className="LoginBanner">
          <img
            loading="lazy"
            src={LoginBanner}
            alt=""
            className="d-md-block d-none"
            width={350}
          />
          <img
            loading="lazy"
            src={LoginBannerMob}
            alt=""
            className="d-md-none d-block"
          />
        </div>
        <div className="LoginRightPart">
          <Modal.Header
            closeButton
            closeVariant="white"
            onClick={() => handleClose()}
          >
            <Modal.Title> Reset Password</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="login-section">
              <div className="Login-rightPart">
                <div className="form-steps">
                  <h2 className="h2">Verify!</h2>
                  <p>Please enter OTP you received on your mobile number</p>
                  <Form>
                    <Form.Group
                      className="mb-3 position-relative"
                      controlId="formBasicPassword"
                    >
                      <Form.Control
                        type="number"
                        placeholder="Enter OTP*"
                        onChange={(e) => setOtpValue(e.target.value)}
                      />
                    </Form.Group>
                    <Form.Group
                      className="mb-3 position-relative"
                      controlId="formBasicPassword"
                    >
                      <Form.Control
                        type={showPassword ? "text" : "password"}
                        placeholder="Enter new password"
                        onChange={(e) => setPassword(e.target.value)}
                      />
                      <span
                        className="icon"
                        onClick={() => setShowPassword((s) => !s)}
                      >
                        {showPassword ? <IoIosEyeOff /> : <IoIosEye />}
                      </span>
                    </Form.Group>
                  </Form>

                  <Button
                    className="btn-primary"
                    variant=""
                    onClick={handleSubmit}
                    disabled={isVerifying}
                  >
                    {!isVerifying ? "SUBMIT" : "SUBMITTING"}
                  </Button>

                  <div className="sign-up mt-4">
                    Already a member?
                    <a href="/sign-in">Sign In here</a>
                  </div>
                </div>
              </div>
            </div>
          </Modal.Body>
        </div>
      </div>
    </Modal>
  );
};
export default ResetPassword;
